module.exports = __webpack_public_path__ + "static/img/banner.bc5e645.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/city-agent/banner.jpg
// module id = QqSX
// module chunks = 4